export default __webpack_public_path__ + "static/media/reactcard.271247d8.png";